// extracted by mini-css-extract-plugin
export default {"page-container":"PageNotFound_page-container__lKmUT"};